// extracted by mini-css-extract-plugin
module.exports = {"accordion":"accordion-component_accordion__3vOTQ","title":"accordion-component_title__3-6kU","rotate":"accordion-component_rotate__2tCSw"};